import React from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, InputNumber, Select, DatePicker, Switch } from 'antd';
import { openNotification } from '../../util/notificaciones';
import SitiosRequest from '../../services/Sitios';
import moment from 'moment'
import 'moment/locale/es';
import BaseComponent from '../Common/BaseComponent';
moment.locale('es')

const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de formulario de variables
 */
class FormVariables extends BaseComponent {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrPorcentajes: [],
        detalleSitio: undefined,
        rangoIncremento: [],
        numero_maximo_entrega: 1,
        response_detalle: null,
    }

    /**
     Clase para ver el proceso carga de datos.
    */
    componentDidMount = () => {
        let state = { ...this.state }
        let porcentajes = [
            { id: 0, nombre: "0%" }, { id: 10, nombre: "10%" }, { id: 20, nombre: "20%" },
            { id: 30, nombre: "30%" }, { id: 40, nombre: "40%" }, { id: 50, nombre: "50%" },
            { id: 60, nombre: "60%" }, { id: 70, nombre: "70%" }, { id: 80, nombre: "80%" },
            { id: 90, nombre: "90%" }, { id: 100, nombre: "100%" }, { id: 110, nombre: "110%" },
            { id: 120, nombre: "120%" }, { id: 130, nombre: "130%" }, { id: 140, nombre: "140%" },
            { id: 150, nombre: "150%" }, { id: 160, nombre: "160%" }, { id: 170, nombre: "170%" },
            { id: 180, nombre: "180%" }, { id: 190, nombre: "190%" }, { id: 200, nombre: "200%" },
        ]

        state.arrPorcentajes = porcentajes
        this.setState(state)
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.tipo_modal === "Uno") {
            if ((this.props.sitio_selected !== prevProps.sitio_selected)) {
                if (this.props.sitio_selected !== null) {
                    let objEnviar = {
                        tipo_modelo: this.props.modelo,
                        categoria: this.props.categoria,
                        drives_id: this.props.sitio_selected.id
                    }
                    this.setState({ cargando: true }, () => {
                        SitiosRequest.DetalleSitio(objEnviar).then(response => {
                            state.response_detalle = response.data
                            state.rangoIncremento = [];
                            state.cargando = false
                            if (response.data.length) {
                                for (let index = 0; index < response.data[0].modelo_pedido.length; index++) {
                                    const element = response.data[0].modelo_pedido[index];
                                    if (
                                        element.categoria === parseInt(this.props.categoria) &&
                                        element.tipo_modelo === parseInt(this.props.modelo)
                                    ) {
                                        state.detalleSitio = response.data[0].modelo_pedido[index];
                                        if (state.detalleSitio !== undefined) {
                                            state.rangoIncremento.push(state.detalleSitio.variables_modelo.incremento_eventualidad.fecha_inicial)
                                            state.rangoIncremento.push(state.detalleSitio.variables_modelo.incremento_eventualidad.fecha_vencimiento)
                                        }
                                    }
                                }
                            }

                            this.setState(state)
                        }).catch(err => {
                            this.setState({ cargando: false })
                            openNotification(
                                "Ha ocurrido un error cargando el detalle del sitio",
                                "Error al cargar detalle del sitio",
                                false
                            )
                        })
                    })
                }
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({ detalleSitio: undefined, response_detalle: null })
    }

    /**
     * Función que se ejecuta cuando se cambia la categoría
     * @param: value. valor de el id de la categoría
     * @return: nada.
     */
    onChangeCategoria = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = value === undefined ? null : value;
        if (value === undefined || value === null) {
            state.bloquearBotones = true
        } else {
            state.bloquearBotones = false
        }

        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se va a confirmar
     * la edición de variables
     * @param: e. valor de el id de la categoría
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    id: "boton-aceptar-confirmacion-variables-form",
                    title: 'Confirmar',
                    content: this.props.tipo_modal === "Uno" ? <div><b>¿Está seguro de la edición de variable?</b> Se cambiará la información del sitio seleccionado.</div> : <div><b>¿Está seguro de la edición de variable?</b> Se cambiará la información de los sitios seleccionados.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-variables-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-viables-form',
                    },
                    onOk: () => {
                        this.setState({ guardando: true, bloquearBotones: true }, this.editarVariablesSitios)
                    },
                });
            }
        });
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en guardar la edición de variables
     * @param: nada.
     * @return: nada.
     */
    editarVariablesSitios = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let objEnviar = {};
                objEnviar.id = state.response_detalle
                objEnviar.tipo_modelo = parseInt(this.props.modelo);
                objEnviar.categoria = parseInt(this.props.categoria);
                objEnviar.sitios = this.props.tipo_modal === "Uno" ? [this.props.sitio_selected.id] : this.props.arrSitios
                objEnviar.variables_modelo = {}
                objEnviar.variables_modelo.id = this.state.detalleSitio?.variables_modelo?.id
                objEnviar.variables_modelo.frecuencia_visita = values.frecuenciaVisita
                objEnviar.variables_modelo.dia_actual_registrado = values.actualRegistrado
                objEnviar.variables_modelo.tiempo_entrega = values.tiempoEntrega
                objEnviar.variables_modelo.tiempo_max_entrega = values.tiempoMaximoEntrega
                objEnviar.variables_modelo.valor = values.incremento_eventualidad
                objEnviar.variables_modelo.porcentaje_seguridad = values.porcentaje_seguridad
                objEnviar.variables_modelo.inventario_interno_cero = values.inventario_interno_cero
                
                objEnviar.variables_modelo.fecha_inicial = moment(new Date(values.rango_incremento[0])).utcOffset(0, false).format("DD/MM/YYYY")
                objEnviar.variables_modelo.fecha_vencimiento = moment(new Date(values.rango_incremento[1])).utcOffset(0, false).format("DD/MM/YYYY")

                state.cargando = true;
                this.setState(state, () => {
                    SitiosRequest.EditarVariablesSitios(objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false
                            this.setState(state, this.props.esconderModal(true))
                            openNotification(
                                "Se han editado las variables correctamente.",
                                "Variables editadas correctamente",
                                true
                            )
                        })
                        .catch(err => {
                            this.setState({ bloquearBotones: false, cargando: false })
                            openNotification(
                                "No se han podido editar las variables.",
                                "Error al editar las variables",
                                false
                            )
                        })
                })
            }
        });
    }

    /**
     * Función que se ejecuta cuando se cambia la cateforía
     * @param: value. valor del número 
     * @return: nada.
     */
    onChangeNumber = (value) => {
        let number = value + 1
        this.setState({ numero_maximo_entrega: number })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title={(this.props.modo !== "ver" ? 'Editar' : 'Ver') + " variables del modelo de pedido" + (this.props.tipo_modal === "Uno" ? " del sitio " + (this.props.sitio_selected !== null ? this.props.sitio_selected.nombre : '') : '')}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "95%" : "70%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-variables"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo !== "ver" ? 'btnVerCrearGuardar' : 'display-none'}
                                key="submit"
                                id="boton-guardar-form-variables"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Tiempo de entrega (días)" : <b>Tiempo de entrega (días)</b>}
                                        colon={(this.props.modo === "ver") ? false : true}>
                                        {getFieldDecorator('tiempoEntrega', {
                                            rules: [
                                                { required: (this.props.modo === "ver") ? false : true, message: 'Por favor, ingrese tiempo de entrega.' },
                                            ],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? this.state.detalleSitio.variables_modelo.tiempo_entrega : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-tiempo-entrega-form-variables"
                                                type="number"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={2}
                                                onChange={this.onChangeNumber}
                                                max={31}
                                                placeholder={"Ingrese tiempo de entrega"}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Tiempo máximo de entrega (días)" : <b>Tiempo máximo de entrega (días)</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}>
                                        {getFieldDecorator('tiempoMaximoEntrega', {
                                            rules: [{ required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese tiempo máximo de entrega.' }],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? this.state.detalleSitio.variables_modelo.tiempo_max_entrega : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-entrega-maxima-form-variables"
                                                type="number"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={this.state.numero_maximo_entrega}
                                                maxLength={2}
                                                max={99}
                                                placeholder={"Ingrese tiempo máximo de entrega"}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Frecuencia de visita semanal (veces)" : <b>Frecuencia de visita semanal (veces)</b>}
                                        colon={(this.props.modo === "ver") ? false : true}>
                                        {getFieldDecorator('frecuenciaVisita', {
                                            rules: [
                                                { required: (this.props.modo === "ver") ? false : true, message: 'Por favor, ingrese frecuencia de visita semanal.' },

                                            ],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? this.state.detalleSitio.variables_modelo.frecuencia_visita : null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-frecuencia-visita-form-variables"
                                                type="number"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={(this.props.modo !== "ver") ? false : true}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={1}
                                                maxLength={1}
                                                max={7}
                                                placeholder={"Ingrese frecuencia de visita semanal"}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Tiempo de respuesta (días)" : <b>Tiempo de respuesta (días)</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}>
                                        {getFieldDecorator('actualRegistrado', {
                                            rules: [
                                                { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese días de entrega.' },
                                            ],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? this.state.detalleSitio.variables_modelo.dia_actual_registrado : null
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-dias-entrega-form-variables"
                                                showSearch
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={this.props.modo !== "ver"}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                <Option value={1}>1</Option>
                                                <Option value={2}>2</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "% de incremento por eventualidad" : <b>% de incremento por eventualidad</b>}
                                        colon={(this.props.modo === "ver") ? false : true}>
                                        {getFieldDecorator('incremento_eventualidad', {
                                            rules: [{ required: (this.props.modo === "ver") ? false : true, message: 'Por favor, seleccione incremento por eventualidad.' }],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? this.state.detalleSitio.variables_modelo.incremento_eventualidad.valor : null
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-incremento-form-variables"
                                                showSearch
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={this.props.modo !== "ver"}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrPorcentajes.length > 0 &&
                                                    this.state.arrPorcentajes.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Rango de fecha para incremento" : <b>Rango de fecha para incremento</b>}
                                        colon={(this.props.modo === "ver") ? false : true}>
                                        {getFieldDecorator('rango_incremento', {
                                            rules: [{ required: (this.props.modo === "ver") ? false : true, message: 'Por favor, seleccione fecha para incremento.' }],
                                            initialValue: (
                                                this.state.detalleSitio !== undefined ? [moment(this.state.rangoIncremento[0]), moment(this.state.rangoIncremento[1])] : []
                                            )
                                        })(
                                            <RangePicker
                                                id="range-incremento-form-variables"
                                                format={dateFormat}
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                placeholder={["Fecha Inicio", "Fecha Fin"]}
                                                disabledDate={(current) => {
                                                    return moment().add(-1, 'days') >= current
                                                }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={this.props.categoria_nombre?.toLowerCase()?.includes('donas') ? '' : 'display-none'} span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "% Stock Seguridad" : <b>% Stock Seguridad</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}>
                                        {getFieldDecorator('porcentaje_seguridad', {
                                            rules: [{ required: (this.props.modo !== "ver" && this.props.categoria_nombre === 'Donas') ? true : false, message: 'Por favor, ingrese stock de seguridad.' }],
                                            initialValue: (
                                                this.state.detalleSitio?.variables_modelo?.porcentaje_seguridad ?? null
                                            )
                                        })(
                                            <InputNumber
                                                style={{ width: "100%" }}
                                                id="input-stock-seguridad-form-variables"
                                                type="number"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                precision={0}
                                                min={1}
                                                maxLength={2}
                                                max={30}
                                                placeholder={"Ingrese stock de seguridad"}
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col className={this.props.categoria_nombre?.toLowerCase()?.includes('donas') ? '' : 'display-none'} span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Inventario interno en 0" : <b>Inventario interno en 0</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}
                                    >
                                    {getFieldDecorator('inventario_interno_cero', {
                                        valuePropName: 'checked',
                                        rules: [{ 
                                            required: (this.props.modo !== "ver" && this.props.categoria_nombre?.toLowerCase()?.includes('donas')) ? true : false, 
                                            message: 'Por favor, ingrese si aplica inventario interno en 0.' 
                                        }],
                                        initialValue: (
                                            this.state.detalleSitio?.variables_modelo?.inventario_interno_cero ?? false
                                        )
                                    })(
                                        <Switch
                                            className={this.props.form.getFieldValue("inventario_interno_cero") ? "colorSwitchActivo" : "colorSwitchInactivo"}
                                            disabled={this.props.modo !== "ver" ? false : true}
                                        />
                                    )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormVariables);